import React, { useEffect, useState } from 'react'
import CandidateJobInvitaionComponent from '../Components/CandidateJobInvitaionComponent';
import { JobInvitationResponse } from '../../InvitatationSystem/Types/InvitationSystemType';
import { getAllJobInvitationsByUserId } from '../../JobPostTemplate/Services/JobPostTemplateService';
import { useParams } from 'react-router-dom';
import CandidateHeaderComponent from '../Components/CandidateHeaderComponent';
import { storage } from '../../Shared/Utils/authStorage';
import LoadMoreButton from '../../Shared/Pagination/LoadMoreButton';
import Pagination from '../../Shared/Pagination/Pagination';

function CandidateJobInvitaionListingPage() {
  const [candidates, setCandidates] = useState<JobInvitationResponse[]>([]);
  const [filteredCandidates, setFilteredCandidates] = useState<JobInvitationResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { id } = useParams();
  const status = id?.toUpperCase() || "ALL"; // Default to "ALL" if no id is provided


  const [page, setPage] = useState(0);
  const [pagination, setPagination] = useState({
    page: 0,
    size: 2,
    totalElements: 0,
    totalPages: 0,
    first: true,
    last: false,
    hasNext: false,
    hasPrevious: false,
  });

    useEffect(() => {
  const fetchCandidates = async () => {
    try {
      const response = await getAllJobInvitationsByUserId(storage.getUserId() ?? "", status, page);
      if (response.success) {
        setCandidates(response.data.content); 


             // Pagination data
 setPagination({
  page: response.data.page,
  size: response.data.size,
  totalElements: response.data.totalElements,
  totalPages: response.data.totalPages,
  first: response.data.first,
  last: response.data.last,
  hasNext: response.data.hasNext,
  hasPrevious: response.data.hasPrevious,
});
      }
    } catch (err) {
      setError("Failed to load candidates");
    } finally {
      setLoading(false);
    }
  };

  fetchCandidates();
}, [page]);


useEffect(() => {
  if (!candidates) return;

  let filtered = candidates;

  if (status !== "ALL") {
    filtered = candidates.filter(
      (item) => item.invitationStatus?.toUpperCase() === status
    );
  }

  setFilteredCandidates(filtered);
}, [status, candidates]);
    
  return (
    <div className="bg-black p-4  border border-slate-700 shadow-xl">
    {/* <CandidateHeaderComponent/> */}
    {filteredCandidates.length === 0 ? (
      <div className="text-center py-16 text-slate-400 font-black tracking-widest uppercase text-xs border border-dashed border-slate-700 rounded-2xl bg-black shadow-inner">
        <span className="text-cyan-400 block mb-1 text-base animate-pulse">⚡</span>
        No Data Found
      </div>
    ) : (
      <CandidateJobInvitaionComponent data={filteredCandidates} />
    )}
  
  <div className="mt-4 pt-4 border-t border-slate-700 flex justify-center">
          <Pagination
            page={pagination.page}
            size={pagination.size}
            totalElements={pagination.totalElements}
            totalPages={pagination.totalPages}
            first={pagination.first}
            last={pagination.last}
            hasNext={pagination.hasNext}
            hasPrevious={pagination.hasPrevious}
            setPage={setPage}
          />
        </div>
  </div>
  )
}

export default CandidateJobInvitaionListingPage